/**
 * Homepage-Switch — auf `/` rendert je nach CMS-Modus die Editorial-
 * Homepage (default) oder die Aktions-Landingpage.
 *
 * Solange der Modus vom Backend geladen wird (~50-200 ms) rendern wir
 * die Editorial-Version (dominanter Standardfall), damit kein FOUC
 * für Direktverkehr entsteht.
 */
import { useHomepageMode } from "@/lib/useAktionsSeite";
import Home from "@/pages/Home";
import AktionHome from "@/pages/AktionHome";

export default function HomeSwitch() {
    const { mode, loaded } = useHomepageMode();
    if (!loaded) return <Home />;
    return mode === "aktion" ? <AktionHome /> : <Home />;
}
